import { Breadcrumbs, Link, Stack, TablePagination, Typography } from "@mui/material";
import { useObrasCadastroareaViewModel } from "../../viewModels/obras_cadastroarea_view_model";
import { ObrasTopHeader } from "../../components/obras_top_header";
import { ObrasReportModals } from "../../components/obras_report_modals";
import { Header } from "./components/header";
import { LegendComponent } from "../../../../../common/components/legend_component";
import { useMemo } from "react";
import { GenerateObrasAreaChecklistColumnDefinition } from "./columns";
import { ObraAreaChecklist } from "../../../domain/models/obra_area_checklist";
import { GRID_CHECKBOX_SELECTION_FIELD, GridPinnedColumnFields } from "@mui/x-data-grid";
import { isValidId } from "../../../../../common/utils/utils";
import { ObraAreaChecklistModal } from "./components/obra_area_checklist_modal";
import { ObraAreaEmpreendimentoChecklistModal } from "./components/obra_area_empreendimento_checklist_modal";
import { LegendTagIcon } from "../../../../../common/components/legend_tag_icon";
import { LegendTagItemComponent } from "../../../../../common/components/legend_tag_item_component";
import { ExcluirChecklistAreaModal } from "./components/excluir_checklist_area_modal";
import { IncluirChecklistAreaModal } from "./components/incluir_checklist_area_modal";
import { CustomStyledDataGrid } from "./components/custom_styled_data_grid";
import { ObraEmpreendimentoBlocos } from "./components/obra_empreendimento_blocos";
import { CopyChecklistAreaModal } from "./components/copy_checklist_area_modal";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import { ObrasTopBar } from "../../components/obras_top_bar";
import { Link as LinkTo } from 'react-router';
import { ReinspecaoEmAbertoModal } from "./components/obra_reinspecao_em_aberto_modal";

import AlertError from "../../../../../common/components/alert_error";
import BottomBar from "../../../../../common/components/bottom_bar";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";

/**
 * ObrasCadastroarea
 */

export const ObrasCadastroarea = () => {
  const viewModel = useObrasCadastroareaViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateObrasAreaChecklistColumnDefinition({
      obraStatus: viewModel.selectedObraHeaderInfo !== null ? viewModel.selectedObraHeaderInfo.status : null,
      onEnterChecklists: viewModel.handleOpenAreaChecklist,
      onActionEditar: viewModel.handleOpenObraAreaChecklistModal,
      onActionDeletar: viewModel.handleDeleteObraAreaChecklistOpenStateModal,
      onActionCopiar: viewModel.handleOpenCopyChecklistAreaModal,
    });
  }, [
    viewModel.selectedObraHeaderInfo,
    viewModel.handleOpenAreaChecklist,
    viewModel.handleOpenObraAreaChecklistModal,
    viewModel.handleDeleteObraAreaChecklistOpenStateModal,
    viewModel.handleOpenCopyChecklistAreaModal,
  ]);

  const isObraEmpreendimento = isValidId(viewModel.selectedObraHeaderInfo?.idEmpreendimento);

  const pinnedColumns = useMemo((): GridPinnedColumnFields => {
    return viewModel.obraAreaChecklists.length > 0 ?
      {
        left: [
          GRID_CHECKBOX_SELECTION_FIELD,
        ],
        right: [
          'idObraAreaChecklist',
          'copiar',
        ],
      } : {
      };
  }, [
    viewModel.obraAreaChecklists,
  ]);

  return (
    <>
      {/**
        * TopBar
        */}

      <ObrasTopBar
        obrasReportState={viewModel.obrasReportState}
        state={viewModel.obrasTopHeaderState}
        selectedObra={viewModel.selectedObraHeaderInfo}
        leftBackSlotButton={
          <div className="flex flex-row gap-2">
            {
              (viewModel.selectedObraHeaderInfo && viewModel.selectedObraHeaderInfo.status === 0) &&
              <>
                <div className="w-[210px]">
                  <PrimaryButton
                    buttonColor="yellow"
                    onClick={() => viewModel.handleOpenIncluirChecklistAreaModal(true)}
                    startIcon={<DynamicIcon nameIcon="Add" size={25} className="text-black" />}>
                    Incluir Checklist X Área
                  </PrimaryButton>
                </div>
                <div className="w-[120px]">
                  <PrimaryButton
                    onClick={() => isObraEmpreendimento
                      ? viewModel.handleOpenObraAreaEmpreendimentoChecklistModal(true)
                      : viewModel.handleOpenObraAreaChecklistModal(null, true)}
                    startIcon={<DynamicIcon nameIcon="Add" size={25} className="text-white" />}>
                    Nova área
                  </PrimaryButton>
                </div>
                <div className="w-[200px]">
                  <PrimaryButton
                    onClick={() => viewModel.relatorioDianmico(null, true)}
                    startIcon={<DynamicIcon nameIcon="Add" size={25} className="text-white" />}>
                    Relatorio Dinâmico
                  </PrimaryButton>
                </div>
              </>
            }
          </div>
        }
        onBack={viewModel.handleBack}
      >
        <div className="flex flex-row gap-2">
          {isObraEmpreendimento &&
            <div className="w-[12rem]">
              <PrimaryButton
                buttonColor="yellow"
                onClick={() => viewModel.handleConfigurarServicos()}>
                Configurar Serviços
              </PrimaryButton>
            </div>
          }
          <div className="">
            <PrimaryButton
              onClick={() => viewModel.handleOpenReinspecaoEmAbertoModal(true)}
              color="warning"
              buttonColor="yellow"
              startIcon={<DynamicIcon nameIcon="Add" size={25} className="text-black-500" />}>
              Reeinspeções em Aberto
            </PrimaryButton>
          </div>
        </div>
      </ObrasTopBar>

      {/**
        * Content
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-24">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Link underline="hover" color="inherit" component={'span'}>
            <LinkTo to='/Obras_lista'>Lista de Obras</LinkTo>
          </Link>
          <Typography className="text-primary-green">
            Checklist de Área
          </Typography>
        </Breadcrumbs>

        <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
          <ObrasTopHeader
            title='Checklist de Área'
            selectedObra={viewModel.selectedObraHeaderInfo}
            onReload={viewModel.handleReload}
          />
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload}
                />
              </div>
            ) : (
              <>
                <Header
                  area={viewModel.filters.area}
                  status={viewModel.filters.status}
                  onAreaChange={viewModel.handleAreaChange}
                  onStatusChange={viewModel.handleStatusChange}
                  onClearFilter={viewModel.handleClearFilter}
                />

                <Stack spacing={0}>
                  <div className="w-full flex flex-row justify-between items-stretch">
                    <div className="flex flex-col flex-wrap">
                      <LegendComponent>
                        <LegendTagItemComponent
                          icon={<LegendTagIcon title='I.A' bgColor="#26C281" />}
                          label='I. Aprovação(%)' />

                        <LegendTagItemComponent
                          icon={<LegendTagIcon title='I.R' bgColor="yellow" />}
                          label='I. Retrabalho(%)' />

                        <LegendTagItemComponent
                          icon={<LegendTagIcon title='I.RA' bgColor="#FFB848" />}
                          label='I. Retrabalho Aprovado(%)' />

                        <LegendTagItemComponent
                          icon={<LegendTagIcon title='I.REP' bgColor="#EF4836" />}
                          label='I. Reprovação(%)' />

                      </LegendComponent>
                    </div>
                  </div>

                  {isObraEmpreendimento ? (
                    <ObraEmpreendimentoBlocos
                      blocos={viewModel.blocosEmpreendimento}
                      loading={viewModel.loading}
                      onClickImovel={viewModel.handleOpenAreaChecklist}
                    />
                  ) : (
                    <CustomStyledDataGrid
                      tableName="obras_cadastroarea"
                      disableColumnMenu={false}
                      getRowId={(row: ObraAreaChecklist) => row.idObraAreaChecklist}
                      columns={columnsDefinition}
                      loading={viewModel.loading}
                      rows={viewModel.obraAreaChecklists}
                      rowCount={viewModel.obraAreaChecklists.length}
                      pinnedColumns={pinnedColumns}
                      checkboxSelection={true}
                      disableRowSelectionOnClick={true}
                      onRowSelectionModelChange={viewModel.handleRowSelectionModelChange}
                      rowSelectionModel={viewModel.rowSelectionModel}
                      pageSizeOptions={[10, 25, 50, 100]}
                      statInformation={viewModel.statInformation}
                      paginationMode="server"
                      paginationModel={{
                        page: viewModel.pagination.page,
                        pageSize: viewModel.pagination.rowsPerPage,
                      }}
                    />
                  )}

                  {!isObraEmpreendimento &&
                    <TablePagination
                      component="div"
                      count={viewModel.pagination.totalItems}
                      page={viewModel.pagination.page - 1}
                      onPageChange={(_, p) => viewModel.handlePageChange(p)}
                      rowsPerPageOptions={[10, 25, 50, 100]}
                      rowsPerPage={viewModel.pagination.rowsPerPage}
                      onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                    />
                  }
                </Stack>
              </>
            )
        }
      </div>

      {/**
        * BottomBar
        */}

      < BottomBar >
        <div className="w-full h-full items-center justify-between flex p-4 gap-4">
          <div className="flex flex-row gap-3">
            {
              isValidId(viewModel.idObra) &&
              <PrimaryButton
                buttonColor="yellow"
                onClick={() => viewModel.handleOpenChangeHistory(null, null)}>
                <span className="text-xs">
                  Historico de alterações
                </span>
              </PrimaryButton>
            }
          </div>

          <div className="flex flex-row gap-4">
            {
              (viewModel.selectedObraHeaderInfo && viewModel.selectedObraHeaderInfo.status === 0) &&
              <>
                <div className="w-[210px]">
                  <PrimaryButton
                    buttonColor="red"
                    onClick={() => viewModel.handleOpenExcluirChecklistAreaModal(true)}
                    startIcon={<DynamicIcon nameIcon="DeleteForever" size={25} className="text-white" />}>
                    Excluir Checklist X Área
                  </PrimaryButton>
                </div>
                <div className="w-[180px]">
                  <PrimaryButton
                    buttonColor="red"
                    onClick={() => viewModel.handleDeleteLoteObraAreaChecklistOpenStateModal(true)}
                    startIcon={<DynamicIcon nameIcon="DeleteForever" size={25} className="text-white" />}>
                    Excluir selecionados
                  </PrimaryButton>
                </div>
              </>
            }
          </div>
        </div>
      </BottomBar>

      {/**
        * Modal Area checklist
        */}

      <ObraAreaChecklistModal
        open={viewModel.openObraAreaChecklist}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedObraAreaChecklist={viewModel.selectedObraAreaChecklist ?? null}
        checklistServicos={viewModel.checklistServicoDropdown ?? []}
        onClose={() => viewModel.handleOpenObraAreaChecklistModal(null, false)}
        onSubmit={viewModel.handleSubmitObraAreaChecklist}
      />

      <ObraAreaEmpreendimentoChecklistModal
        open={viewModel.openObraAreaEmpreendimentoChecklist}
        saving={viewModel.saving}
        loading={viewModel.loading}
        blocos={viewModel.blocosEmpreendimento}
        checklistServicos={viewModel.checklistServicoDropdown ?? []}
        onClose={() => viewModel.handleOpenObraAreaEmpreendimentoChecklistModal(false)}
        onSubmit={viewModel.handleSubmitObraAreaEmpreendimentoChecklist}
      />

      <IncluirChecklistAreaModal
        open={viewModel.openIncluirChecklistArea}
        saving={viewModel.saving}
        loading={viewModel.loading}
        areas={viewModel.filters.obraAreaChecklists ?? []}
        checklists={viewModel.checklistServicoDropdown ?? []}
        onClose={() => viewModel.handleOpenIncluirChecklistAreaModal(false)}
        onSubmit={viewModel.handleObraServicosIncluirSubmit}
        onSelectedAreasChange={viewModel.handleSelectedAreasChange}
      />

      <ExcluirChecklistAreaModal
        open={viewModel.openExcluirChecklistArea}
        saving={viewModel.saving}
        loading={viewModel.loading}
        areas={viewModel.filters.obraAreaChecklists ?? []}
        checklists={viewModel.filters.excOrIncObraChecklistServicos ?? []}
        onChecklistChange={viewModel.handleObraAreaExcluirChecklistChange}
        onClose={() => viewModel.handleOpenExcluirChecklistAreaModal(false)}
        onSubmit={viewModel.handleObraServicosExcluirSubmit}
      />

      <CopyChecklistAreaModal
        open={viewModel.openCopyChecklistArea}
        saving={viewModel.saving}
        loading={viewModel.loading}
        onClose={() => viewModel.handleOpenCopyChecklistAreaModal(null, false)}
        onSubmit={viewModel.handleCopyObraAreaChecklistSubmit}
      />

      <DeleteDialog
        open={viewModel.openObraAreaChecklistDelete}
        saving={viewModel.saving}
        title='Você realmente deseja excluir este item?'
        onClose={() => viewModel.handleDeleteObraAreaChecklistOpenStateModal(null, false)}
        onDelete={() => viewModel.handleDeleteObraAreaChecklistConfirm()}
      />

      <DeleteDialog
        open={viewModel.openObraAreaChecklistLoteDelete}
        saving={viewModel.saving}
        title='Você realmente deseja excluir os itens selecionados?'
        onClose={() => viewModel.handleDeleteLoteObraAreaChecklistOpenStateModal(false)}
        onDelete={() => viewModel.handleDeleteLoteObraAreaChecklistConfirm()}
      />

      {/**
        * Relatorios obras.
        */}

      <ObrasReportModals
        state={viewModel.obrasReportState}
      />

      {/**
        * Modal historico de alterações.
        */}

      <ChangeHistoryModal
        changeHistoryHandler={viewModel.changeHistory}
      />

      <ReinspecaoEmAbertoModal
        open={viewModel.openReinspecaoEmAberto}
        loading={viewModel.loading}
        lista={viewModel.reinspecaoEmAbertoLista}
        checklists={viewModel.checklistServicoDropdown ?? []}
        area={viewModel.filtersReinspecao.area ?? null}
        pagination={viewModel.reinspecaoEmAbertoPagination}
        idsObraChecklistServicos={viewModel.filtersReinspecao.idsObraChecklistServicos ?? []}
        onObraAreaChecklistChange={viewModel.handleAreaReinspecaoChange}
        onChecklistServicoChange={viewModel.handleIdChecklistServicoReinspecaoChange}
        onClearFilters={viewModel.handleClearReinspecaoFilters}
        onClose={() => viewModel.handleOpenReinspecaoEmAbertoModal(false)}
        onRedirectToReinspecaoEmAberto={viewModel.handleRedirectToReinspecaoEmAberto}
        onPageChange={viewModel.handleReinspecaoEmAbertoPageChange}
        onRowsPerPageChange={viewModel.handleReinspecaoEmAbertoRowsPerPageChange}
      />

    </>
  );
}